import React, { useContext, useEffect, useMemo, useState } from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { checkIfPastDate, hideMorePopover } from '../helper/function'
import { SpinnerContext } from '../context/spinnerContext'

import ClenderImg from '../assets/img/svg/calender-black.svg'
import PersonImg from '../assets/img/svg/person-black.svg'
import CleanningImg from '../assets/img/svg/cleanning-black.svg'
import CheckoutImg from '../assets/img/svg/checkout-icon.svg'
import CheckinImg from '../assets/img/svg/checkin-icon.svg'
import CustomModal from './customModal'
import CancelModalContent from './scheduleStatus/canceleModalContent'
import ScheduledModalContent from './scheduleStatus/scheduledModalContent'
import StatusModal from './modal/statusModal'
import { getSchedulePropertyDataById } from '../redux/slices/propertySlice'

const FullCalendarView = ({ calendarRef, onDatasetChange = null, CALENDAR_EVENT = null, setIsRefresh, height = 730, maxEventsCount = 3 }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { scheduledProperties } = useSelector((state) => state.property)
  const { changeLoader } = useContext(SpinnerContext)
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false)
  const [modalName, setModalName] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [dayMaxEvents, setDayMaxEvents] = useState(2)
  const [chatUserId, setChatUserId] = useState(null)
  const [contentHeight, setContentHeight] = useState(height)
  const toggleModal = () => setShowModal(!showModal)

  const clientName = useMemo(
    () =>
      scheduledProperties?.getPropertyScheduleData?.properties?.client
        ? scheduledProperties?.getPropertyScheduleData?.properties?.client?.first_name +
          ' ' +
          scheduledProperties?.getPropertyScheduleData?.properties?.client?.last_name
        : '',
    [scheduledProperties?.getPropertyScheduleData]
  )

  useEffect(() => {
    const updateDayMaxEvents = () => {
      const width = window.innerWidth
      if (width < 768) {
        setDayMaxEvents(0)
      } else {
        setDayMaxEvents(maxEventsCount)
      }
    }
    updateDayMaxEvents()
    window.addEventListener('resize', updateDayMaxEvents)
    return () => {
      window.removeEventListener('resize', updateDayMaxEvents)
    }
  }, [])

  const customDataRender = (info) => {
    const { status, host_name, accepted, checkout, next_check_in, cleaner_name } = info
    const cssColor = accepted === 'Accepted' ? 'accepted_text' : accepted === 'Pending' ? 'pennding_text' : 'declined_text'
    const statusColor =
      status === 'scheduled'
        ? 'calendar_schedule_text'
        : status === 'completed'
          ? 'calendar_completed_text'
          : status === 'in progress'
            ? 'calendar_inprogress_text'
            : ['canceled cleaner', 'canceled']?.includes(status)
              ? 'calendar_cancelled_text'
              : 'calendar_schedule_text'
    return `
      <div class="custom-data-render-wrapper">
      <div className="status"><img src=${ClenderImg} alt="image"/><span class=${statusColor}>${status}</span></div>
      ${host_name ? `<div className="host"><img src=${PersonImg} alt="image"/>${host_name}</div>` : ''}
      ${cleaner_name ? `<div className="host"><img src=${CleanningImg} alt="image"/>${cleaner_name} : <span class=${cssColor}>${accepted}</span> </div>` : ''}
      ${checkout ? `<div className="checkout"><img src=${CheckoutImg} alt="image"/>Checkout: <span>${checkout}</span></div>` : ''}
      ${next_check_in ? `<div className="next_check_in"><img src=${CheckinImg} alt="image"/>Next Check-In: <span>${next_check_in}</span></div>` : ''}
      </div>  
    `
  }

  const eventRender = (info) => {
    const tooltip = document.createElement('div')
    info.el.appendChild(tooltip)
    tooltip.innerHTML = customDataRender(info.event.extendedProps)
  }

  const handleYearButtonClick = () => {
    const calendarApi = calendarRef?.current?.getApi()
    calendarApi?.changeView('yearView')
  }

  const overFun = useMemo(() => {
    return scheduledProperties?.getPropertyScheduleData?.next_checkin_time
      ? checkIfPastDate(scheduledProperties?.getPropertyScheduleData?.next_checkin_time, false)
      : checkIfPastDate(scheduledProperties?.getPropertyScheduleData?.booking_date_time, true)
  }, [scheduledProperties?.getPropertyScheduleData])

  const customViews = {
    yearView: {
      type: 'dayGrid',
      duration: { years: 1 },
      buttonText: 'Year',
      date: new Date().getFullYear(),
      eventRender: eventRender
    }
  }

  const handleEventClick = (value) => {
    const extendedProps = value?.event?.extendedProps
    const { status, properties_id } = extendedProps
    setChatUserId(properties_id)
    if (['scheduled', 'canceled', 'in progress', 'canceled cleaner']?.includes(status)) {
      getPropertyData(properties_id, status)
    } else if (['completed']?.includes(status)) {
      navigate(`/${`calendar`}/complete-cleaning/${properties_id}/cleaningDetail`)
    }
  }

  const handleDataSetChange = (arg) => {
    onDatasetChange && onDatasetChange(arg)
    const button = document.querySelector('.fc-yearButton-button')
    const isYearView = arg.view.type === 'yearView'
    if (isYearView) {
      button.classList.add('fc-button-active')
    } else {
      button.classList.remove('fc-button-active')
    }
  }

  const getPropertyData = async (schedule_id, status) => {
    hideMorePopover()
    changeLoader(true)
    await dispatch(getSchedulePropertyDataById(schedule_id))
      .then(() => {
        setIsStatusModalOpen(true)
        setModalName(status)
        changeLoader(false)
      })
      .catch(() => {
        changeLoader(false)
      })
  }
  useEffect(() => {
    const doc = document.getElementById('mobile_btn')
    if (doc) {
      const displayStyle = window.getComputedStyle(doc).display

      if (displayStyle === 'block') {
        console.log('mobile')
        setContentHeight('auto')
      }
    }
  }, [])
  return (
    <div>
      <FullCalendar
        timeZone="local"
        ref={calendarRef}
        height={height}
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'yearButton,timeGridWeek,dayGridMonth,timeGridDay'
        }}
        customButtons={{
          yearButton: {
            text: 'Year',
            click: function () {
              handleYearButtonClick(this)
            }
          }
        }}
        aspectRatio={1.35}
        contentHeight={contentHeight}
        views={customViews}
        initialView="dayGridMonth"
        editable={false}
        selectable={false}
        selectMirror={true}
        dayMaxEvents={dayMaxEvents}
        eventDidMount={eventRender}
        eventClick={handleEventClick}
        events={CALENDAR_EVENT}
        eventContent={renderEventContent}
        datesSet={(arg) => handleDataSetChange(arg)}
      />
      <CustomModal isOpen={showModal} toggle={toggleModal} size={'lg'} title={'Cleaning Information'}>
        <div>ABC</div>
      </CustomModal>
      {isStatusModalOpen && (
        <StatusModal
          onClose={() => setIsStatusModalOpen(false)}
          title={`Cleaning #${scheduledProperties?.getPropertyScheduleData?.schedule_number}`}
          headerContent={{
            name: clientName,
            status: scheduledProperties?.getPropertyScheduleData?.booking_status
          }}
          chatUserId={chatUserId}
          CheckTimeOver={overFun}
          clientId={scheduledProperties?.getPropertyScheduleData?.properties?.client?.client_id}
        >
          {['canceled', 'canceled cleaner']?.includes(modalName) && (
            <CancelModalContent
              data={scheduledProperties?.getPropertyScheduleData}
              finalAmount={scheduledProperties?.finalAmount}
              onClose={() => setIsStatusModalOpen(false)}
            />
          )}
          {['scheduled', 'in progress']?.includes(modalName) && (
            <ScheduledModalContent
              data={scheduledProperties?.getPropertyScheduleData}
              setIsRefresh={setIsRefresh}
              onClose={() => setIsStatusModalOpen(false)}
              page={`calendar`}
            />
          )}
        </StatusModal>
      )}
    </div>
  )
}

export default FullCalendarView

function renderEventContent(eventInfo) {
  const event = eventInfo?.event?._def
  return (
    <div className="event-container">
      <ul className="event-list">
        <li className="event-item">
          <b className="event-title">{event?.title}</b>
        </li>
      </ul>
    </div>
  )
}
